export const keyword_Apart_Tab_Arr = [
  { text: 'Add Keywords', value: 'Add_Keywords' },
  { text: "Competitor's Keywords", value: "Competitor's_Keywords" },
  { text: 'Category Keywords', value: 'Category_Keywords' },
  { text: 'Keywords by Description', value: 'Keywords_by_Description' },
  // { text: 'Keywords by Download', value: 'Keywords_by_Download' },
  { text: 'Keywords Research', value: 'Keywords_Research' },
  { text: 'Ranked Keywords', value: 'Ranked_Keywords' },
];

export const keyword_Bpart_Tab_Arr = [
  { text: 'Tracked Keywords', value: 'Tracked_Keywords' },
  { text: 'Competition Analysis', value: 'Competition_Analysis' },
  { text: 'Ranking History', value: 'Ranking_History' },
];

export enum bpart_popup_Type {
  live = 'LIVE',
  suggest = 'SUGGEST',
}

export type bpart_popup = 'LIVE' | 'SUGGEST' | null;

//  Analyze Keyword > keyword tracking > Bpart > Tracked Keywords 그리드차트 rowColors 리스트
export const bpart_rowColors = ['white', '#c6f2e8', '#d1e7a7', '#ffdd95', '#feb4ae', '#ebdbf0'];

//
export const popup_Suggest_TrackType = {
  add: 'add',
  del: 'del',
};

export enum popup_Category {
  'related' = 'RELATED',
  'search' = 'SEARCH',
}

// Analyze Keyword > keyword tracking > Bpart > competition analysis > all Ranks select 리스트
export const AllRanksSelectList = [
  { text: 'All Ranks', value: 'All' },
  { text: '1-100', value: '1-100' },
  { text: '100-500', value: '100-500' },
  { text: '500-1000', value: '500-1000' },
  { text: '1000-5000', value: '5000-10000' },
];

// Analyze Keyword > keyword tracking > Bpart > competition analysis > All SearchScore select 리스트
export const AllScoresSelectList = [
  { text: 'All Score', value: 'All' },
  { text: '90+', value: 90 },
  { text: '80+', value: 80 },
  { text: '70+', value: 70 },
  { text: '60+', value: 60 },
  { text: '50+', value: 50 },
  { text: '40+', value: 40 },
  { text: '30+', value: 30 },
];

// Analyze Keyword > keyword tracking > Bpart > competition analysis > All Chance select 리스트
export const AllChanceSelectList = [
  { text: 'All Chance', value: 'All' },
  { text: '90+', value: 90 },
  { text: '80+', value: 80 },
  { text: '70+', value: 70 },
  { text: '60+', value: 60 },
  { text: '50+', value: 50 },
  { text: '40+', value: 40 },
  { text: '30+', value: 30 },
];

// Analyze Keyword > keyword tracking > Bpart > competition analysis > All Diff select 리스트
export const AllDiffSelectList = [
  { text: 'All Diff', value: 'All' },
  { text: '90+', value: 90 },
  { text: '80+', value: 80 },
  { text: '70+', value: 70 },
  { text: '60+', value: 60 },
  { text: '50+', value: 50 },
  { text: '40+', value: 40 },
  { text: '30+', value: 30 },
];

// Analyze Keyword > keyword Optimization
export const OptimizationTabObjList = [
  { title: 'Title', text: 'App Title', value: 'title', limitLength: 30 },
  { title: 'Sub Title', text: 'SubTitle', value: 'subTitle', limitLength: 30 },
  { title: 'App Store Connect Keywords', text: 'Keywords', value: 'appStoreConnectKeywords', limitLength: 100 },
  { title: 'Description', text: 'Description', value: 'description', limitLength: 4000 },
];

// keyword request
export const requestType = {
  idle: 'idle',
  pending: 'pending',
  fulfilled: 'fulfilled',
  rejected: 'rejected',
};
